import React from 'react'
import '../styles/404.css'

const PageNotFound = props => (
    <div className="PageNotFound d-flex justify-content-center align-items-center">
        <div className="container">
            <h1 className="headingXX text-center c-text">
                Ops!<br /> Página não encontrada.
            </h1>
        </div>
    </div>
)

export default PageNotFound